import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { PayloadAction } from "@reduxjs/toolkit";
import {
  failurelistSubjectNote,
  successlistSubjectNote,
} from "./SubjectStudyNode";
import {
  IStudy,
  IStudycontant,
  IStudytopic,
  IStudytopicsub,
} from "../../../Pages/StudyNote.tsx/IStudyNote";
import {
  failureListSubjectNoteTopicSlice,
  successListSubjectNoteTopicSlice,
} from "./TopicStudyNode";
import {
  failureListSubjectNoteSubTopicSlice,
  successListSubjectNoteSubTopicSlice,
} from "./TopicSubStudyNode";
import {
  failureListSubjectNoteContentSlice,
  successListSubjectNoteContentSlice,
} from "./TopicStudyNodeContent";

// SUbject Study node
const ListStudyNoteSubjectSliceApi = () => {
  return api.get("/api/formula/get/subject");
};

export function* ListStudyNoteSubjectSliceCall(action: PayloadAction<IStudy>) {
  try {
    const response: AxiosResponse = yield call(ListStudyNoteSubjectSliceApi);
    yield put(successlistSubjectNote(response.data));
  } catch (error) {
    yield put(failurelistSubjectNote(error));
  }
}

// study topic
const ListStudyNoteSubjectTopicSliceApi = (
  action: PayloadAction<IStudytopic>
) => {
  return api.get("/api/formula/get/topic", { params: action.payload });
};

export function* ListStudyNoteSubjectTopicSliceCall(
  action: PayloadAction<IStudytopic>
) {
  try {
    const response: AxiosResponse = yield call(
      ListStudyNoteSubjectTopicSliceApi,
      action
    );
    yield put(successListSubjectNoteTopicSlice(response.data));
  } catch (error) {
    yield put(failureListSubjectNoteTopicSlice(error));
  }
}

// study sub
const ListStudyNoteSubjectTopicSubSliceApi = (
  action: PayloadAction<IStudytopicsub>
) => {
  return api.get("/api/formula/get/subtopic", { params: action.payload });
};

export function* ListStudyNoteSubjectTopicSubSliceCall(
  action: PayloadAction<IStudytopicsub>
) {
  try {
    const response: AxiosResponse = yield call(
      ListStudyNoteSubjectTopicSubSliceApi,
      action
    );
    yield put(successListSubjectNoteSubTopicSlice(response.data));
  } catch (error) {
    yield put(failureListSubjectNoteSubTopicSlice(error));
  }
}

// study Content
const ListStudyContentliceApi = (action: PayloadAction<IStudycontant>) => {
  return api.get("/api/formula/get/content", { params: action.payload });
};

export function* ListStudyContentSliceCall(
  action: PayloadAction<IStudycontant>
) {
  try {
    const response: AxiosResponse = yield call(ListStudyContentliceApi, action);
    yield put(successListSubjectNoteContentSlice(response.data));
  } catch (error) {
    yield put(failureListSubjectNoteContentSlice(error));
  }
}
